import {gql} from "@apollo/client";


export const JOB_CATEGORY_LIST = gql`
query GetAllJobCategories {
    jobCategories {
      id
      category
      label
      jobs {
        label
        id
        baseSkills {
          key
          label
          id
        }
      }
    }
}
`;
